import React, {ReactElement} from "react";
import {classes} from "./doppe-viewer-map.st.css";
import {GoogleMapView, useEventCallback} from "@wix/devzai-utils-react";
import {DoppeViewerMapModalContent} from "./doppe-viewer-map-modal-content/doppe-viewer-map-modal-content";
import type {LocationCoordinates} from "@wix/devzai-utils-common";
import {DoppeActionMediaOverlayButton} from "../doppe-action-media-overlay-button/doppe-action-media-overlay-button";

export const DoppeViewerMap = React.memo((props: DoppeViewerMap.Props) => {
    const {
        openModal,
        locationCoordinates,
        languageCode,
        openModalText,
        navigateToText,
        openWidthText,
        modalZoom,
        previewZoom
    } = props;

    const openMapModal = useEventCallback(() => {
        if (openModal && locationCoordinates) {
            openModal?.(
                <DoppeViewerMapModalContent
                    locationCoordinates={locationCoordinates}
                    languageCode={languageCode}
                    zoom={modalZoom}
                    openWithText={openWidthText}
                    navigateToText={navigateToText}
                />
            );
        }
    });

    if (!locationCoordinates) return null;

    return <div className={classes.root}>
        <GoogleMapView
            className={classes.map}
            locationCoordinates={locationCoordinates}
            zoom={previewZoom}
            languageCode={languageCode}
            displayMode='Static'
            onClick={openMapModal}
        />
        <DoppeActionMediaOverlayButton
            onClick={openMapModal}
        >
            {openModalText}
        </DoppeActionMediaOverlayButton>
    </div>;
});

export namespace DoppeViewerMap {
    export interface Props extends React.HTMLAttributes<any> {
        openModal?: (modalContent: ReactElement) => void;
        locationCoordinates: LocationCoordinates;
        languageCode: string;
        previewZoom: number;
        modalZoom: number;
        openModalText: string;
        navigateToText: string;
        openWidthText: string;
    }
}
